import { BackgroundJobStatus } from 'types/graphql'

export const BackgroundJobStatusValue = {
  Pending: 'Pending',
  InProgress: 'InProgress',
  Completed: 'Completed',
  Failed: 'Failed',
  PartiallyCompleted: 'PartiallyCompleted',
  Cancelled: 'Cancelled',
} as const satisfies { [K in BackgroundJobStatus]: K }

/** Pending and InProgress both render as the active pill (spinner, cancel, progress copy). */
export const isActiveBackgroundJobStatus = (status: BackgroundJobStatus) =>
  status === BackgroundJobStatusValue.Pending || status === BackgroundJobStatusValue.InProgress
